module.exports = __webpack_public_path__ + "static/media/gzl.ea6bb84e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/displayBoard/gzl.svg
// module id = 4795
// module chunks = 0